export default {
    appName: "REP",
    customerSuccessURL: " https://retailsolutions.force.com/s/contactsupport"
};
